// Full-page navigation to the hosted Neon checkout — isolated behind a seam
// so the checkout flow stays unit-testable without a real browser navigation.
export function fullPageRedirect(url: string): void {
  window.location.assign(url);
}
